var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","background-color":"#121212"}},[_c('devices-dashboard-list',{on:{"finishedloading":_vm.finishedloading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }